import {gql} from '@apollo/client'

export const GET_ALL_VALIDATIONS = gql`
  query identityValidationList(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $documentNumber: String
    $status_Iexact: CoreIdentityValidationStatusChoices
    $step_Iexact: CoreIdentityValidationStepChoices
    $created_Gte: DateTime
    $created_Lte: DateTime
    $name: String
  ) {
    identityValidationList(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      documentNumber: $documentNumber
      status_Iexact: $status_Iexact
      step_Iexact: $step_Iexact
      created_Gte: $created_Gte
      created_Lte: $created_Lte
      name: $name
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          created
          firstName
          secondName
          firstSurname
          secondSurname
          documentType
          documentNumber
          expeditionDate
          phoneNumber
          status
        }
      }
    }
  }
`

export const GET_ONE_VALIDATION = gql`
  query identityValidationList($id: ID) {
    identityValidationList(id: $id) {
      edges {
        node {
          id
          created
          firstName
          secondName
          firstSurname
          secondSurname
          documentType
          documentNumber
          expeditionDate
          phoneNumber
          status
          step
          identityvalidationmetadataSet {
            edges {
              node {
                id
                metadata
                step
              }
            }
          }
        }
      }
    }
  }
`
